<template>
  <div id="lp1">
    <div class="container">
      <div class="row" style="max-width: 1140px !important; margin: auto;">
        <div class="p-5 col-10 lpp col-md-5"></div>
        <div class="mx-auto bg-white shadow rounded p-5 col-12 lpp col-md-5">
          <h4>Receber código de acesso</h4>
          <p>Informe por qual meio quer receber seu código de acesso</p>
          <form
            v-on:submit="sendNewContact"
            v-on:submit.prevent
            name="contact-form"
          >
            <div class="form-group">
              <div class="form-row px-1">
                <div class="col-12">
                  <p>Escolha como deseja receber o código</p>
                </div>
                <div
                  class="custom-control custom-radio custom-control-inline mr-5"
                  style="margin-bottom: 10px"
                >
                  <input
                    type="radio"
                    value="email"
                    class="custom-control-input"
                    id="email-r"
                    name="EmailOrPhone"
                    v-model="EmailOrPhone"
                    @click="(email = true), (sms = false)"
                  />
                  <label class="custom-control-label" for="email-r"
                    >Por E-mail</label
                  >
                </div>
                <div
                  class="custom-control custom-radio custom-control-inline"
                  style="margin-bottom: 10px"
                >
                  <input
                    type="radio"
                    id="sms-r"
                    value="sms"
                    name="EmailOrPhone"
                    class="custom-control-input"
                    v-model="EmailOrPhone"
                    @click="(sms = true), (email = false)"
                  />
                  <label class="custom-control-label" for="sms-r"
                    >Por SMS</label
                  >
                </div>
                <multiselect
                  v-model="form.emailSelected"
                  v-if="email && form.emailList.length > 0"
                  :multiple="false"
                  :select-label="'selecionar'"
                  deselect-label="remover"
                  track-by="Email"
                  label="Email"
                  placeholder="Selecione um e-mail"
                  :options="form.emailList"
                  :searchable="false"
                  :allow-empty="true"
                >
                  <template slot="singleLabel" slot-scope="{ option }">{{
                    option.Email
                  }}</template>
                  <template v-slot:noOptions
                    >Não foi encontrado nenhum email cadastrado</template
                  >
                </multiselect>
                <div v-if="email && form.emailList.length > 0" class="col-12">
                  <p class="text-info" style="margin-bottom: 0px">
                    Ou se preferir, informe um novo e-mail:
                  </p>
                </div>

                <input
                  v-if="email"
                  type="email"
                  class="form-control"
                  placeholder="Informe um e-mail"
                  id="formEmail"
                  v-model="form.newEmail"
                  @input="typeNewEmail"

                />

                <!-- <input v-if="email && form.emailList.length < 1" type="email" autocomplete="email" class="form-control" placeholder="Informe um e-mail" id="formEmail" v-model="form.emailSelected"> -->

                <multiselect
                  @click="removeEquals(form)"
                  v-if="sms && form.phoneList.length > 0"
                  v-model="form.phoneSelected"
                  :multiple="false"
                  :select-label="'selecionar'"
                  deselect-label="remover"
                  track-by="PhoneNumber"
                  label="PhoneNumber"
                  placeholder="Selecione um telefone"
                  :options="form.phoneList"
                  :searchable="true"
                  :allow-empty="true"
                >
                  <template slot="singleLabel" slot-scope="{ option }">{{
                    option.PhoneNumber
                  }}</template>
                  <template v-slot:noOptions
                    >Não foi encontrado nenhum telefone</template
                  >
                </multiselect>
                <div v-if="sms && form.phoneList.length > 0" class="col-12">
                  <p class="text-info" style="margin-bottom: 0px">
                    Ou se preferir, informe um novo número:
                  </p>
                </div>

                <input
                  v-if="sms"
                  type="tel"
                  class="form-control"
                  placeholder="Informe um telefone"
                  id="form9"
                  v-model="form.newPhone"
                  @input="typeNewPhone"
                  v-mask="['(##) # ####-####']"
                />
              </div>
            </div>
            <div class="form-group mb-3">
              <small class="form-text text-muted text-right float-right">
                <a href="#" v-if="!loading" @click="voltar()"
                  >Lembrei meu código</a
                >
              </small>
            </div>
            <ProgressLoading v-bind:loading="loading" />
            <button
              type="submit"
              class="btn btn-secondary text-white"
              href="#"
              v-if="!loading"
            >
              Receber código
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import ProgressLoading from "./ProgressLoading.vue";
import Multiselect from "vue-multiselect";

import { formatRemovePhoneMask } from "@/utils/helpers";

export default {
  name: "FormSendCode",
  components: {
    ProgressLoading,
    Multiselect,
  },
  props: {
    dialogModal: {
      type: Boolean,
    },
  },

  data() {
    return {
      EmailOrPhone: "email",
      isHomolog: false,
      telefone: {
        items: [],
        value: null,
      },
      telefoneSelect: "",
      EmailSelect: "",
      form: {
        email: null,
        promoCode: null,
        emailSelected: [],
        phoneSelected: [],
        emailList: [],
        phoneList: [],
        newEmail: null,
        newPhone: null,
      },
      error: {
        alert: false,
        status: null,
        message: null,
      },
      loading: false,
      dialog: false,
      promoCode: null,
      sendCode: false,
      email: true,
      sms: false,
      code: false,
      emailDebtor: null,
      smsDebtor: null,
      infoDebtor: null,

      phoneNumberFinal: null,
      emailFinal: null,
      emailsListWithoutMask: [],
      phoneListWithoutMask: [],
      largura: null,
      ipUser: null
    };
  },
  mixins: [validationMixin],
  directives: { mask },
  validations: {
    form: {
      email: { required, email },
      telefone: { required, minLength: minLength(16) },
    },
  },
  computed: {
    ...mapState("auth", ["contacts"]),
    classMessage: function () {
      return {
        "text-danger": this.error.status == "ERROR",
        "text-muted": !this.error.status == "ERROR",
      };
    },
    telefoneErrors() {
      const errors = [];
      if (!this.$v.form.telefone.$dirty) return errors;
      !this.$v.form.telefone.minLength &&
        errors.push("Digite um Telefone válido");

      return errors;
    },

    emailErrors() {
      const errors = [];
      if (!this.$v.form.email.$dirty) return errors;
      !this.$v.form.email.email && errors.push("Digite um e-mail válido!");

      return errors;
    },
  },

  async created() {
    this.ipUser = localStorage.getItem('ipUser');
    var valueFromEnv = await this.ActionIsHomolog();
    this.isHomolog = valueFromEnv == 1;

    if (typeof this.contacts.ListEmailsWithMask.Email !== "undefined") {
      this.contacts.ListEmailsWithMask.Email.map((email) => {
        this.form.emailList.push({
          Email: email,
        });
      });

      this.form.emailSelected = this.contacts.ListEmailsWithMask.Email;
    } else {
      this.form.emailSelected = "";
    }

    if (typeof this.contacts.ListPhonesWithMask.PhoneNumber !== "undefined") {
      this.contacts.ListPhonesWithMask.PhoneNumber.map((phone) => {
        this.form.phoneList.push({
          PhoneNumber: phone,
        });
      });

      this.form.phoneSelected = this.contacts.ListPhonesWithMask.PhoneNumber;
    } else {
      this.form.phoneSelected = "";
    }

    this.contacts.Emails
      ? this.emailsListWithoutMask.push({ Email: this.contacts.Emails })
      : "";

    this.phoneListWithoutMask.push(this.contacts.PhonesWithoutMask);
    this.removeEquals(this.form);
  },
  methods: {
    ...mapActions("auth", [
      "ActionSendPromoCode",
      "ActionSetCurrentForm",
      "ActionCreateDebtor",
      "ActionSetContacts",
      "ActionResetState",
      "ActionIsHomolog",
    ]),
    formatRemovePhoneMask,
    exitDialog() {
      this.$emit("setDialog", false);
    },
    keyhandler: function (event) {
      event.preventDefault();
    },

    voltar() {
      this.$destroy();
      this.ActionSetCurrentForm("form-doc-number");
    },

    selectEmail(e) {
      this.form.email = e;
      this.emailSelect = e;
    },
    selectPhone(e) {
      this.form.telefone = this.telefone.items[e];
      this.telefoneSelect = this.telefone.items[e];
      console.log(this.telefoneSelect);

      window.$(".dropdown-menu").removeClass("show");
      this.EmailOrPhone = "email";
      this.EmailOrPhone = "telefone";
    },

    typeNewEmail() {
      this.form.emailSelected = [];
    },

    typeNewPhone() {
      this.form.phoneSelected = [];
    },

    async sendNewContact(e) {
      this.emailFinal = null;
      this.phoneNumberFinal = null;

      //eslint-disable-next-line
      // debugger;


      e.preventDefault();
      this.$v.$touch();
      if (this.email) {
        if (this.form.newEmail === null && !this.form.emailSelected.Email) {
          this.flashMessage.show({
            timeout: 300,
            status: "error",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Erro",
            message: "informe ao menos um meio de contato",
          });
          return;
        }
        if (this.form.emailSelected != null && this.form.emailSelected != "") {
          this.emailFinal = this.contacts.Emails[0];
        } else {
          this.emailFinal = this.form.newEmail;
        }
      }

      if (this.sms) {
        if (
          this.form.newPhone === null &&
          !this.form.phoneSelected.PhoneNumber
        ) {
          this.flashMessage.show({
            timeout: 300,
            status: "error",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Erro",
            message: "informe ao menos um meio de contato",
          });
          return;
        }

        if (this.form.phoneSelected != null && this.form.phoneSelected != "") {
          var chosenPhone = this.form.phoneSelected.PhoneNumber
            ? this.form.phoneSelected.PhoneNumber
            : this.form.phoneSelected;
          var fourLastNumbersPhone = chosenPhone.slice(chosenPhone.length - 4);
          var lastFourDigits = null;

          this.phoneListWithoutMask.map((phone) => {
            if (phone.PhoneNumber) {
              phone.PhoneNumber.map((item) => {
                lastFourDigits = item.slice(item.length - 4);

                if (lastFourDigits === fourLastNumbersPhone) {
                  this.phoneNumberFinal = item;
                }
              });
            }
          });
        } else {
          this.phoneNumberFinal = this.form.newPhone;
        }
      }

      this.loading = true;
      this.telefoneErrors.pop();

      if (this.contacts.SourceInfo === "API_EXTERNA") {
        try {
          var response = await this.ActionCreateDebtor({
            DocNumber: this.contacts.DocNumber,
            Email: this.emailFinal,
            PhoneNumber:
              this.phoneNumberFinal != null
                ? this.phoneNumberFinal
                    .replace("(", "")
                    .replace(")", "")
                    .replace(" ", "")
                    .replace(" ", "")
                    .replace("-", "")
                : null,
            OS: navigator.platform,
            IP: this.ipUser ? this.ipUser : '',
          });

          console.log("response21123: " + JSON.stringify(response));

          if (response.status === 200) {
            this.ActionSetContacts({
              DebtorID: response.data.results.DebtorID,
            });
            this.flashMessage.show({
              timeout: 300,
              status: "success",
              position: "top right",
              blockClass: "custom-block-class",
              title: "Sucesso",
              message: "código enviado com sucesso",
            });
            this.ActionSetCurrentForm("form-promo-code");
            this.loading = false;
          } else {
            this.loading = false;
            this.error.status = "ERROR";

            this.flashMessage.show({
              timeout: 300,
              status: "error",
              position: "top right",
              blockClass: "custom-block-class",
              title: "Erro",
              message:
                "ocorreu um erro ao tentar enviar o promocode, tente novamente mais tarde",
            });
          }
        } catch (error) {
          this.flashMessage.show({
            timeout: 300,
            status: "error",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Erro",
            message: error.data.message,
          });

          this.error.status = "ERROR";
        }
      } else {

        var result = await this.ActionSendPromoCode({
          DebtorId: this.contacts.DebtorID,
          Email: this.emailFinal,
          PhoneNumber:
            this.phoneNumberFinal != null
              ? this.phoneNumberFinal
                  .replace("(", "")
                  .replace(")", "")
                  .replace(" ", "")
                  .replace(" ", "")
                  .replace("-", "")
              : null,
          IP: this.ipUser ? this.ipUser : '',
        });

        console.log("result: " + JSON.stringify(result));

        if (result.status === 500) {
          this.flashMessage.show({
            timeout: 300,
            status: "error",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Erro",
            message: result?.error?.message ?? "Erro na solicitação",
          });
        } else {
          this.flashMessage.show({
            timeout: 300,
            status: "success",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Sucesso",
            message: "código enviado com sucesso",
          });

          this.ActionSetCurrentForm("form-promo-code");
        }
      }
      this.loading = false;
      // }
    },
    removeEquals(form) {
      let newPhoneList = [];
      form.phoneList.map((value, key) => {
        if (!newPhoneList.includes(value.PhoneNumber))
          newPhoneList.push(value.PhoneNumber);
        else delete this.form.phoneList[key];
      });
    },
  },
};
</script>
